import React, { CSSProperties, useState, useRef } from 'react';

import useOnClickOutside from 'hooks/useClickOutside';

import './DropDown.scss';

enum HorizontalPositions {
  'right',
  'center',
  'left',
}
enum VerticalPositions {
  'top',
  'center',
  'bottom',
}

type Horizontal = keyof typeof HorizontalPositions;
type Vertical = keyof typeof VerticalPositions;

interface Props {
  children?: React.ReactNode;
  style?: CSSProperties;
  icon?: React.ReactNode;
  tooltipElement?: React.ReactNode;
  boxStyle?: CSSProperties;
  selectMultiple?: boolean;
  anchorOrigin?: {
    horizontal: Horizontal;
    vertical: Vertical;
  };
  position?: 'right' | 'left';
}

const DropDown: React.FC<Props> = ({
  style,
  children,
  icon,
  boxStyle,
  selectMultiple = false,
  anchorOrigin = { horizontal: 'right', vertical: 'bottom' },
  position = 'left',
}) => {
  const [isVisible, setIsVisible] = useState(false);

  function hideDrodownEl(multipleCheck: boolean) {
    if (multipleCheck) return;
    setIsVisible(false);
  }

  const clickRef = useRef(null);
  useOnClickOutside(clickRef, () => hideDrodownEl(false));

  return (
    <div className="dropdown" ref={clickRef} style={style}>
      <div className="dropdown-icon pointer" onClick={() => setIsVisible(!isVisible)}>
        {icon}
      </div>
      {isVisible && (
        <div className={`${position && position}`}>
          <div
            className={`dropdown-elements  ${
              anchorOrigin &&
              `horizontal-${anchorOrigin.horizontal} vertical-${anchorOrigin.vertical}`
            } `}
            onClick={() => hideDrodownEl(selectMultiple)}
            style={boxStyle}
          >
            {children}
          </div>
        </div>
      )}
    </div>
  );
};

export default DropDown;
